import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogErrorComponent } from '@components/dialog-error/dialog-error.component';

@Injectable()
export class DialogErrorService {

  constructor(public dialog: MatDialog) { }

  public openDialog(errorCode: number): void {
    this.dialog.open(DialogErrorComponent,
      {
        panelClass: 'dialog-error',
        disableClose: true,
        data: { errorCode }
      }
    );
  }
}
